import { h, Fragment } from "preact";
//import { useState, useEffect, useContext } from "preact/hooks";
import {
	Alert,
	Box,
	Button,
	Card,
	CardContent,
	CardMedia,
	Grid,
	Stack,
	Typography,

} from "@mui/material";
import CircularProgressWithLabel from "./CircularProgressWithLabel";
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';

export default function DealCard({ dl, idx, mode, app, ctx }) {
	//console.log("DealCard", dl);
	const acceptDealAsAmbassador = (uid) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/ae3705295b9f46c5b883179b7110204f/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const declineDealAsAmbassador = (uid) => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/efb2f5b9c1bc46e2a43ba3e2890fcab2/" + uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const clickHandler = () => {
		if (mode === "A") {
			if (dl.acc_amb === true) {


				ctx.user_undone.length == 0 ? window.location.href = "/7bac6cb9d6ee4d70b1315393725f3a34/" + dl.u :

					app.refPopUp.current.handleChangeState(
						{
							opened: true,
							type: "005",

						})
			} else {
				app.refPopUp.current.handleChangeState(
					{
						opened: true,
						type: "001",
						params: {
							title: "Attention",
							body: (
								<div>
									<Typography variant="body1" gutterBottom>
										Vous devez accepter la mission avant de pouvoir consulter ce dossier de vente
									</Typography>
								</div>
							)
						}
					}
				)

			}
		}
		if (mode === "V") {
			ctx.user_undone.length == 0 ? window.location.href = "/11d1355181ac4376a09980601b420617/" + dl.u :

				app.refPopUp.current.handleChangeState(
					{
						opened: true,
						type: "005",

					})
		}

	}
	//console.log("DealCard", mode);
	return (<Card sx={{ display: 'flex' }} style="margin-bottom: 10px;">
		{dl.main_pic && <CardMedia
			component="img"
			sx={{ width: 100 }}
			image={`${THUMBS_URL}/${dl.u}/${dl.main_pic.uid}-main.jpg`}
			alt=""
			onClick={clickHandler}
			style="cursor: pointer;"
		/>}
		<CardContent
			//	sx={{ flex: '1 0 auto' }}
			style="padding: 10px; background-color: #f7f7f7b3; width: 100%;">
			<Grid
				container
			>
				<Grid item sm={12} md={7} onClick={clickHandler} style="cursor: pointer;">
					<Stack spacing={1}>
						<Typography component="div" variant="h5">
							Dossier de vente {idx + 1}
						</Typography>
						<Typography component="div" variant="h5">
							{dl.d != undefined ? dl.d : <em>Pas de nom enregistré</em>}
						</Typography>
						<Typography variant="body2" color="text.secondary" component="div">
							{dl.v != undefined ? dl.v : <em>Pas de vendeur enregistré</em>}
						</Typography>
						<Typography variant="body2" color="text.secondary" component="div">
							{dl.mn != undefined ? dl.mn : <em>Pas d'adresse enregistrée</em>}
						</Typography>
					</Stack>
				</Grid>
				<Grid item sm={12} md={5}>
					<Stack display={"flex"} justifyContent="center" alignItems={"center"} style="height: 100%;">
						{(mode === "V" || (mode == "A" && dl.acc_amb === true)) &&
							<Box display="flex" alignItems="center" justifyContent="flex-start" >
								<Box >
									<Grid container >
										<Grid item sm={4} md={12}>
											{mode == "V" && dl.is_amb && <Box display={"flex"} justifyContent="center">
												<Box p={1}>
													<Button variant="contained" onClick={() => {
														window.location.href = "/7bac6cb9d6ee4d70b1315393725f3a34/" + dl.u;
													}}
													>
														Ambassadeur
													</Button>
												</Box>

											</Box>}
											{mode == "A" && dl.is_seller && <Box display={"flex"} justifyContent="center">
												<Box p={1}>
													<Button variant="contained" onClick={() => {
														window.location.href = "/11d1355181ac4376a09980601b420617/" + dl.u;
													}}
													>
														Vendeur
													</Button>
												</Box>

											</Box>}
											<Box display="flex" alignItems="center" justifyContent={"center"} >
												<Box p={1}>
													<CircularProgressWithLabel value={dl.iss ? 100 : (dl.off ? 80 : (dl.bid ? 60 : (dl.pub ? 40 : 20)))} />
												</Box>
												<Box p={1}>
													<Typography variant="h5">
														{dl.iss ? "Acte authentique" : (dl.off ? "Promesse" : (dl.bid ? "Offre" : (dl.pub ? "En vente" : "En constitution")))}
													</Typography>
												</Box>
											</Box>
										</Grid>
										<Grid item sm={8} md={12}>
											{mode == "A" && dl.md.length > 0 && <Box display={"flex"} justifyContent="center">
												<Box p={1}>
													<PlaylistAddCircleIcon color="primary" />
												</Box>
												<Box p={1}>
													<Typography>Il reste {dl.md.length} action{dl.md.length > 1 ? "s" : ""} à faire</Typography>
												</Box>
											</Box>}

											{mode == "A" && dl.md.length == 0 && !dl.pub && <Box display={"flex"} justifyContent="space-between">
												<Alert severity={"warning"} icon={false}>
													Votre vendeur doit finaliser le dossier de vente
												</Alert>
											</Box>}
										</Grid>
									</Grid>
								</Box>
							</Box>
						}
						{mode === "A" && dl.acc_amb === null && <Box display="flex" alignItems="center" justifyContent="flex-start"   >
							<Box p={1}>
								<Button variant="contained" onClick={() => acceptDealAsAmbassador(dl.u)}>Accepter</Button>
								<Button

									onClick={() => {
										setStateYesNoDialog({
											...stateYesNoDialog,
											open: true,
											yes_action: () => {
												declineDealAsAmbassador(dl.u);
											},
											title: "Attention",
											body: (
												<div>
													<Typography variant="h5" gutterBottom>
														Voulez vous vraiment refuser cette mission?
													</Typography>
												</div>
											),
										});
									}}
								>
									Refuser
								</Button>
							</Box>
						</Box>
						}
					</Stack>
				</Grid>
			</Grid>
		</CardContent >

	</Card >)
}